<ion-content class="qvs-error">
  <qvs-svg-icon class="qvs-error__icon" [src]="src | assetByColorMode" [title]="'error-icon'"></qvs-svg-icon>
  <h2 class="qvs-error__title">
    {{ 'error.SOMETHING_WENT_WRONG' | translate }}
  </h2>
  <p class="qvs-error__description">
    {{ description | translate }}
  </p>
  <ion-button (click)="contactUs()" class="qvs-error__button">
    {{ 'error.CONTACT_US' | translate }}
  </ion-button>
</ion-content>
